import { formatDateToLocale, formatToCurrency } from "@utils/formatting";
import { Button } from "@components/ui/button";

interface Props {
  totalHours: number;
  totalAmount: number;
  lastPayoutDate: string | null;
  onRequestPayout: () => void;
}

export const TeacherBalanceTopbar = ({ totalHours, totalAmount, lastPayoutDate, onRequestPayout }: Props) => {
  return (
    <div className="flex flex-1 items-center justify-between">
      <p className="text-xs text-amber-800 dark:text-amber-200 lg:text-sm">
        <strong>{totalHours}</strong> heure(s) déclarée(s) (<strong>{formatToCurrency(totalAmount)}</strong>) restent à être payées
        {lastPayoutDate ? ` depuis le dernier règlement le ${formatDateToLocale(lastPayoutDate)}` : ""}
      </p>
      <Button
        onClick={e => {
          e.stopPropagation();
          onRequestPayout();
        }}
        className="text-xs lg:text-sm"
      >
        Demander le règlement
      </Button>
    </div>
  );
};
